import { formatToCurrency, has } from "shared/utils";
import { formatTitleFirstWord } from "utils/formatTitle";
import { cx } from "utils/classnames";
import { Check, Minus } from "untitledui-js-base";
import { Cell } from "../Cell";
import { ApplicantOrInvitee } from "../../types";
import { HugeiconsIcon } from "@hugeicons/react";
import { CashbackIcon } from "@hugeicons-pro/core-stroke-rounded";

const iconMap = {
  paid: <Check size="20" className="stroke-success-600" />,
  refunded: (
    <HugeiconsIcon icon={CashbackIcon} size="20" className="text-warning-500" />
  ),
  unpaid: <Minus className="stroke-content-200" />
};

export const FeeCell = ({
  applicant: applicantOrInvitee,
  feeType
}: {
  applicant: ApplicantOrInvitee;
  feeType: "administration_fee" | "holding_fee";
}) => {
  const fee = applicantOrInvitee.fee_statuses?.find(
    (feeStatus) => feeStatus.fee_type === feeType
  );
  const feeStatus = fee?.status ?? "not_applicable";

  if (feeStatus === "not_applicable" || feeStatus === "no_fee")
    return <Cell isFirst isDataCell></Cell>;

  return (
    <Cell isFirst isDataCell>
      <div className="flex gap-2 items-center">
        {fee && iconMap[fee.status]}
        <p
          className={cx(
            "font-medium",
            feeStatus === "unpaid" ? "text-content-200" : "text-content-1000"
          )}
        >
          {formatTitleFirstWord(feeStatus)}
        </p>
        <p
          className={cx(
            feeStatus === "unpaid" ? "text-content-200" : "text-content-300"
          )}
        >
          (
          <span>
            {feeStatus === "refunded" &&
              fee?.refunded_amount &&
              `${formatToCurrency(fee.refunded_amount, {
                minimumFractionDigits: 2
              })} of `}
          </span>
          <span>
            {has(fee?.amount) &&
              formatToCurrency(fee.amount, {
                minimumFractionDigits: 2
              })}
          </span>
          )
        </p>
      </div>
    </Cell>
  );
};
